export class CorrectEventData {
  sessionId!: string | null
  initialWord!: string
  correctWord!: string
}

export class BrowseCategoryEventData {
  sessionId!: string | null
  categoryName!: string
  categoryUrl!: string
  searchPhrase!: string
  pageNum!: number
}

export class ExitEventData {
  sessionId!: string | null
  searchPhrase!: string
  totalFound!: number
  maxRelevance!: number
}

export class ExitWithProductEventData extends ExitEventData {
  productName!: string
  productUrl!: string
}

export class ExitWithCategoryEventData extends ExitEventData {
  categoryName!: string
  categoryUrl!: string
}
